import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { PreRegisterFormValues } from 'utilities/resources/formItemValues'

const SceneComponent: React.FC = () => {
  const location = useLocation()
  const formValues = (location.state as PreRegisterFormValues) ?? {
    email: 'mail@example.com',
  }
  return (
    <>
      <Header title="コネクター仮登録が完了しました" />
      <main>
        <section className="mx-4 my-5">
          <div>
            <p>{formValues.email}</p>
            <p className="fw-bold">メールが送信されました</p>
          </div>
          <div className="mt-5">
            <p>ご登録のメールアドレスにAUBEクエストコネクターの登録フォームの案内メールを送信しましたのでご確認ください。</p>
            <p>案内メールが届かない場合、迷惑メールフォルダに振り分けられている可能性があります。</p>
            <p>メールに記載されているリンクをクリックするとポジション数の確認、概要書面の確認、お申込みの入力フォームが表示されますので入力を行うよう進めて下さい</p>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href={'/login'}>
              ログイン画面へ戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
